import { useIntl } from "react-intl";

import testIds from "constants/testIds";
import { getTimezoneOffset, resolvePreferredTimezone } from "helpers/dateTimeHelper";
import { getLabelWithTranslationFallback } from "helpers/getLabel";
import usePermissions from "hooks/usePermissions";
import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import ShipmentDateTimeField from "@RequestFormV2/sections/Provider/components/DeadlinesSection/ShipmentDateTimeField";
import { usePickupExceedsWarningMessage } from "@RequestFormV2/sections/Provider/hooks/usePickupExceedsWarningMessage";

export default function DeadlinesSection() {
  const intl = useIntl();
  const { parsedPermissions } = usePermissions();
  const utcOffset = getTimezoneOffset(resolvePreferredTimezone(parsedPermissions?.preferred_timezone));
  const quotingExceedsPickupMessage = usePickupExceedsWarningMessage(
    "quoting",
    "shipment.quoting_deadline_date",
    "shipment.quoting_deadline_time",
  );
  const confirmationExceedsPickupMessage = usePickupExceedsWarningMessage(
    "confirmation",
    "shipment.confirmation_date",
    "shipment.confirmation_time",
  );

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.provider.deadlines.label",
          defaultMessage: "Deadlines",
        })}
        supportingText={intl.formatMessage(
          {
            id: "request-form.provider.deadlines.description",
            defaultMessage: "Set deadlines for providers {utcOffset}",
          },
          { utcOffset },
        )}
        required
      />

      <div className="rfv2-form-section__content">
        <div className="rfv2-deadlines-fields">
          <ShipmentDateTimeField
            dateName="shipment.quoting_deadline_date"
            timeName="shipment.quoting_deadline_time"
            dateLabel={getLabelWithTranslationFallback("Quoting deadline", {
              translation: intl.formatMessage({
                id: "request-form.provider.deadlines.quotingDeadline",
                defaultMessage: "Quoting deadline",
              }),
              returnAsString: true,
              withoutInfo: true,
            })}
            labelInfo={intl.formatMessage({
              id: "request-form.provider.deadlines.quotingDeadlineInfo",
              defaultMessage: "Date where providers can no longer submit their quotes in",
            })}
            required
            dateTestId={testIds.REQUEST_FORM_PROVIDER_TIMING_QUOTING_DEADLINE_DATE}
            timeTestId={testIds.REQUEST_FORM_PROVIDER_TIMING_QUOTING_DEADLINE_TIME}
            pickupExceedsWarningMessage={quotingExceedsPickupMessage}
          />

          <ShipmentDateTimeField
            dateName="shipment.confirmation_date"
            timeName="shipment.confirmation_time"
            dateLabel={getLabelWithTranslationFallback("Confirmation time", {
              translation: intl.formatMessage({
                id: "request-form.provider.deadlines.confirmationDate",
                defaultMessage: "Confirmation date",
              }),
              returnAsString: true,
              withoutInfo: true,
            })}
            labelInfo={intl.formatMessage({
              id: "request-form.provider.deadlines.confirmationDeadlineInfo",
              defaultMessage: "Date where you have to book one of the quotes.",
            })}
            required
            dateTestId={testIds.REQUEST_FORM_PROVIDER_TIMING_CONFIRMATION_DATE}
            timeTestId={testIds.REQUEST_FORM_PROVIDER_TIMING_CONFIRMATION_TIME}
            showConfirmationAfterQuotingError
            pickupExceedsWarningMessage={confirmationExceedsPickupMessage}
          />
        </div>
      </div>
    </div>
  );
}
